(() => {
    document.addEventListener('DOMContentLoaded', function() {
      // Function to check cart and handle visibility
      function checkCartAndHandleDeliveryBlock(cartData) {
        if (!cartData || !cartData.items) {
          console.log('Cart data is not in expected format:', cartData);
          return;
        }
  
        // Check if any product is NOT of type 'Event'
        const hasNonEventProduct = cartData.items.some(item => {
          return item.product_type !== 'Event';
        });
  
        // Get both delivery blocks
        const deliveryBlocks = document.querySelectorAll('.identixweb-order-delivery, .identixweb-order-delivery.odd-drawer-selector');
        
        if (deliveryBlocks.length > 0) {
          deliveryBlocks.forEach(block => {
            if (hasNonEventProduct) {
              block.style.display = 'block';
              console.log('Showing delivery block - Non-Event product found');
            } else {
              block.style.display = 'none';
              console.log('Hiding delivery block - Only Event products');
            }
          });
        }
      }
  
      // Function to initialize cart check
      function initializeCartCheck() {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            checkCartAndHandleDeliveryBlock(cart);
          })
          .catch(error => {
            console.error('Error fetching cart:', error);
          });
      }
  
      // Create an observer to watch for the delivery sections
      const observer = new MutationObserver((mutations, obs) => {
        const deliveryBlocks = document.querySelectorAll('.identixweb-order-delivery, .identixweb-order-delivery.odd-drawer-selector');
        if (deliveryBlocks.length > 0) {
          console.log('Delivery sections found');
          initializeCartCheck();
          obs.disconnect(); // Stop observing once we've found the elements
        }
      });
  
      // Start observing
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
  
      // Listen for product added to cart
      document.addEventListener('ajaxProduct:added', function(evt) {
        const cartData = evt.detail?.cart;
        
        if (cartData) {
          checkCartAndHandleDeliveryBlock(cartData);
        } else {
          initializeCartCheck();
        }
      });
  
      // Listen for cart updates
      document.addEventListener('cart:updated', function(evt) {
        console.log('Cart updated event triggered');
        initializeCartCheck();
      });
    });
  })();